'use strict';

var Backbone = require('backbone');
var moment = require('moment-timezone');

export default Backbone.View.extend({

  tagName: 'td',
  className: 'date-picker-day',
  attributes: {
    tabindex: '0',
  },

  initialize: function (options) {
    this.start = options.start;
    this.min = options.min;
    this.max = options.max || null;
    this.current = options.current;
    this.length = options.length;
    this.month = options.month;
    this.collection = options.collection || {};

    if (this.isToday()) {
      this.$el.addClass('today');
    }
  },

  isCurrent: function () {
    var start = this.current.clone().subtract(1, 'day'),
      end = this.current.clone().add(this.length, 'days');

    return this.start.isBetween(start, end, 'day');
  },

  isDisabled: function () {
    if (this.start.isBefore(this.min, 'day')) {
      return true;
    }

    if (this.max && !this.start.isBefore(this.max, 'day')) {
      return true;
    }

    if (!this.start.isSame(this.month, 'month')) {
      return true;
    }

    return false;
  },

  isToday: function () {
    var today = moment.now();

    return this.start.isSame(today, 'day');
  },

  hasAvailability: function () {
    if (Object.keys(this.collection).length) {
      return this.collection.attributes.time.length > 0;
    }
  },

  render: function () {
    if (this.isDisabled()) {
      this.$el.addClass('disabled');
    } else {
      this.$el.removeClass('disabled');
    }
    if (this.isCurrent()) {
      this.$el.addClass('current');
    } else {
      this.$el.removeClass('current');
    }
    this.$el.html('<time datetime="' + this.start.format('YYYY-MM-DD') + '">' + this.start.format('D') + '</time>');

    const spanClass = this.hasAvailability() && !this.isDisabled() ? 'dot' : 'no-dot';
    this.$el.append(`<span class="${spanClass}"></span>`);

    return this;
  },

});
